module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.containerClass,
    style: (_vm.containerStyle)
  }, [_c('div', {
    ref: "scrollHeader",
    staticClass: "p-datatable-scrollable-header",
    on: {
      "scroll": _vm.onHeaderScroll
    }
  }, [_c('div', {
    ref: "scrollHeaderBox",
    staticClass: "p-datatable-scrollable-header-box"
  }, [_c('table', {
    staticClass: "p-datatable-scrollable-header-table"
  }, [_c('colgroup', [_vm._l((_vm.columns), function(col, i) {
    return [(_vm.shouldRenderCol(col)) ? _c('col', {
      key: col.columnKey || col.field || i,
      style: (col.headerStyle)
    }) : _vm._e()]
  })], 2), _vm._v(" "), _vm._t("header"), _vm._v(" "), _vm._t("frozenbody")], 2)])]), _vm._v(" "), _c('div', {
    ref: "scrollBody",
    staticClass: "p-datatable-scrollable-body",
    style: (_vm.bodyStyle),
    on: {
      "scroll": _vm.onBodyScroll
    }
  }, [_c('table', {
    ref: "scrollTable",
    class: _vm.bodyTableClass,
    style: (_vm.bodyTableStyle)
  }, [_c('colgroup', [_vm._l((_vm.columns), function(col, i) {
    return [(_vm.shouldRenderCol(col)) ? _c('col', {
      key: col.columnKey || col.field || i,
      style: (col.bodyStyle || col.headerStyle)
    }) : _vm._e()]
  })], 2), _vm._v(" "), _vm._t("body")], 2), _vm._v(" "), (_vm.virtualScroll) ? _c('table', {
    ref: "loadingTable",
    staticClass: "p-datatable-scrollable-body-table p-datatable-loading-virtual-table p-datatable-virtual-table",
    style: ({
      top: '0',
      display: 'none'
    })
  }, [_c('colgroup', _vm._l((_vm.columns), function(col, i) {
    return _c('col', {
      key: col.columnKey || col.field || i,
      style: (col.bodyStyle || col.headerStyle)
    })
  }), 0), _vm._v(" "), _c('DTTableLoadingBody', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "virtualScroller",
    staticClass: "p-datatable-virtual-scroller"
  })]), _vm._v(" "), _c('div', {
    ref: "scrollFooter",
    staticClass: "p-datatable-scrollable-footer"
  }, [_c('div', {
    ref: "scrollFooterBox",
    staticClass: "p-datatable-scrollable-footer-box"
  }, [_c('table', {
    staticClass: "p-datatable-scrollable-footer-table"
  }, [_c('colgroup', [_vm._l((_vm.columns), function(col, i) {
    return [(_vm.shouldRenderCol(col)) ? _c('col', {
      key: col.columnKey || col.field || i,
      style: (col.footerStyle || col.headerStyle)
    }) : _vm._e()]
  })], 2), _vm._v(" "), _vm._t("footer")], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0eb687ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/datatable/ScrollableView.vue
// module id = 2042
// module chunks = 0